const sectionSubcribeEmailCss = `
[data-type='section-subcribe-email'] [data-attribute='card-container'] {
  padding: 40px 0;
}

[data-type='section-subcribe-email'] .wrap-card .title-card {
  font-size: 24px;
  font-weight: bold !important;
  margin: 0 0 16px 0 !important;
  text-align: center;
}

[data-type='section-subcribe-email'] .wrap-card .description-card {
  font-size: 16px;
  margin: 0 0 30px 0 !important;
  text-align: center;
}

[data-type='section-subcribe-email'] .wrap-card .form-subcribe {
  display: block;
}

[data-type='section-subcribe-email'] .wrap-card .wrap-input-email {
  width: fit-content;
  margin: 0 auto;
  position: relative;
}

[data-type='section-subcribe-email'] .wrap-card .wrap-input-email .input-email {
  display: block;
  min-width: 365px;
  padding: 10px 50px 10px 15px;
  border: solid 1px var(--border-color, #c1c1c1);
  font-size: 16px;
  line-height: 24px;
  outline: #000000;
}

[data-type='section-subcribe-email'] .wrap-card .wrap-input-email .input-email:focus {
  outline: #000000 !important;
  border: solid 1px var(--border-color, #000000);
}

[data-type='section-subcribe-email'] .wrap-card .wrap-input-email .input-email::placeholder {
  color: var(--text-color, #000000);
  opacity: 0.8;
}

[data-type='section-subcribe-email'] .wrap-card .wrap-input-email .button-submit {
  background-color: transparent;
  color: var(--text-color, #000000) !important;
  display: flex;
  width: 40px;
  align-items: center;
  justify-content: center;
  position: absolute;
  height: 100%;
  right: 0;
  top: 0;
  padding: 0 !important;
}

[data-type='section-subcribe-email'] .wrap-card .wrap-input-email .button-submit svg {
  display: block;
  width: 15px;
  height: auto;
}

@container (max-width: 768px) {
  [data-type='section-subcribe-email'] [data-attribute='card-container'] {
    padding: 16px 0;
  }

  [data-type='section-subcribe-email'] .wrap-card .title-card {
    font-size: 16px;
  }
}
`;

export default sectionSubcribeEmailCss;
